import V1 from '@/system/v1/SystemV1'
import { ISystem } from '@/contracts/system/interface/ISystem'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemConfig from '@/contracts/system/configs/SystemConfig'

export class SystemProvider extends Provider<ISystem> {
  realizations: Record<string, ISystem> = {
    v1: V1(),
  }
}

const instance: { module: ISystem | null } = { module: null }

export function sys(): ISystem {
  const version = SystemConfig.getVersion()

  if (!instance.module) {
    instance.module = new SystemProvider().module(version)
  }

  return instance.module
}
